import { render, staticRenderFns } from "./verifiersList.vue?vue&type=template&id=5e88725a&"
import script from "./verifiersList.vue?vue&type=script&lang=js&"
export * from "./verifiersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports